var _path, _rect, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20 10.0048C20 15.5137 15.5116 20 10 20C4.48842 20 0 15.5137 0 10.0048C0 4.48625 4.48842 0 10 0C15.5116 0 20 4.48625 20 10.0048Z",
    fill: "url(#paint0_linear_1401_33618)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 6,
    width: 2.5,
    height: 8,
    rx: 1,
    fill: "url(#paint1_linear_1401_33618)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 6,
    width: 2.5,
    height: 8,
    rx: 1,
    fill: "url(#paint2_linear_1401_33618)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1401_33618",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1401_33618",
    x1: 6.25,
    y1: 6,
    x2: 6.25,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1401_33618",
    x1: 11.25,
    y1: 6,
    x2: 11.25,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPause);
export default __webpack_public_path__ + "static/media/ic_pause.187a5738b354fa508795181f79bf78ba.svg";
export { ForwardRef as ReactComponent };